import { d as defineCustomElement } from "./utilities-D68o91ht.js";
import "./dialog-njA3j9df.js";
import "./component-CZdU8SYg.js";
import "./events-C4hlH4zR.js";
let submitHandlerAttached = false;
function attachSubmitHandler() {
  if (submitHandlerAttached) {
    return;
  }
  submitHandlerAttached = true;
  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) {
        return;
      }
      if (!form.getAttribute("action")?.includes("/cart/add")) {
        return;
      }
      if (document.querySelector("special-sale-selector")) {
        return;
      }
      const checkedInputs = Array.from(
        document.querySelectorAll(
          'product-upsell-toggle[data-variant-id] input[type="checkbox"]:checked'
        )
      );
      if (checkedInputs.length === 0) {
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      const originalData = new FormData(form);
      const mainId = originalData.get("id");
      const mainQty = originalData.get("quantity") || "1";
      if (!mainId) {
        return;
      }
      const payload = new FormData();
      payload.append("items[0][id]", String(mainId));
      payload.append("items[0][quantity]", String(mainQty));
      for (const [key, value] of originalData.entries()) {
        if (key.startsWith("properties[") && key.endsWith("]")) {
          const propName = key.slice("properties[".length, -1);
          payload.append(`items[0][properties][${propName}]`, value);
        }
      }
      const upsellsToReset = [];
      const discountCodes = /* @__PURE__ */ new Set();
      checkedInputs.forEach((input, idx) => {
        const toggle = input.closest("product-upsell-toggle");
        const variantId = toggle?.dataset.variantId;
        if (!variantId) {
          return;
        }
        const i = idx + 1;
        payload.append(`items[${i}][id]`, variantId);
        payload.append(`items[${i}][quantity]`, "1");
        if (toggle.dataset.discountCode) {
          discountCodes.add(toggle.dataset.discountCode);
        }
        upsellsToReset.push(input);
      });
      const onRequestEnd = (e) => {
        if (e.detail?.requestState?.requestType !== "add") {
          return;
        }
        document.removeEventListener("liquid-ajax-cart:request-end", onRequestEnd);
        if (e.detail?.requestState?.responseData?.ok) {
          upsellsToReset.forEach((input) => {
            input.checked = false;
          });
          if (discountCodes.size > 0) {
            const code = [...discountCodes][0];
            fetch(`/discount/${encodeURIComponent(code)}`, { credentials: "same-origin" })
              .then(() => window.liquidAjaxCart.get())
              .catch(() => {});
          }
        }
      };
      document.addEventListener("liquid-ajax-cart:request-end", onRequestEnd);
      if (!window.liquidAjaxCart) {
        return;
      }
      window.liquidAjaxCart.add(payload);
    },
    { capture: true }
  );
}
class ProductUpsellToggle extends HTMLElement {
  connectedCallback() {
    attachSubmitHandler();
  }
}
defineCustomElement("product-upsell-toggle", ProductUpsellToggle);
const SHEET_SELECTOR = ".upsell-info-modal";
const STAGE_SELECTOR = ".upsell-info-modal__stage";
const MOBILE_QUERY = "(max-width: 767px)";
const CLOSE_RATIO = 0.25;
const CLOSE_MIN = 80;
const GALLERY_SWIPE_MIN = 40;
const LOCK_MIN = 6;
let sheet = null;
let mode = "idle";
let canDismiss = false;
let stageEl = null;
let startY = 0;
let startX = 0;
let deltaY = 0;
let deltaX = 0;
const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;
const closestOpenSheet = (eventTarget) =>
  eventTarget instanceof Element ? eventTarget.closest(`${SHEET_SELECTOR}[open]`) : null;
function reset() {
  if (sheet && mode !== "sheet") {
    sheet.style.transition = "";
  }
  sheet = null;
  mode = "idle";
  canDismiss = false;
  stageEl = null;
  deltaY = 0;
  deltaX = 0;
}
function flipGallery(stage, dx) {
  const gallery = stage.closest(".upsell-info-modal__gallery");
  const arrow = gallery?.querySelector(
    dx < 0 ? ".upsell-info-modal__nav--next" : ".upsell-info-modal__nav--prev"
  );
  arrow?.click();
}
function onTouchStart(event) {
  const target = closestOpenSheet(event.target);
  if (!target) {
    return;
  }
  event.stopPropagation();
  if (event.touches.length !== 1) {
    return;
  }
  sheet = target;
  mode = "pending";
  canDismiss = isMobile() && target.scrollTop === 0;
  stageEl = event.target.closest(STAGE_SELECTOR);
  startY = event.touches[0].clientY;
  startX = event.touches[0].clientX;
  deltaY = 0;
  deltaX = 0;
  if (canDismiss) {
    sheet.style.transition = "none";
  }
}
function onTouchMove(event) {
  if (mode === "idle" || !sheet) {
    return;
  }
  const touch = event.touches[0];
  const dy = touch.clientY - startY;
  const dx = touch.clientX - startX;
  if (mode === "pending") {
    if (Math.abs(dx) < LOCK_MIN && Math.abs(dy) < LOCK_MIN) {
      return;
    }
    if (Math.abs(dx) > Math.abs(dy)) {
      if (stageEl) {
        mode = "gallery";
      } else {
        reset();
        return;
      }
    } else if (dy > 0 && canDismiss) {
      mode = "sheet";
    } else {
      reset();
      return;
    }
  }
  if (mode === "gallery") {
    deltaX = dx;
    event.preventDefault();
    return;
  }
  deltaY = Math.max(0, dy);
  event.preventDefault();
  sheet.style.transform = `translateY(${deltaY}px)`;
}
function onTouchEnd(event) {
  if (mode === "idle" || !sheet) {
    return;
  }
  const current = sheet;
  const cancelled = event.type === "touchcancel";
  if (mode === "gallery") {
    if (!cancelled && stageEl && Math.abs(deltaX) >= GALLERY_SWIPE_MIN) {
      flipGallery(stageEl, deltaX);
    }
    reset();
    return;
  }
  if (mode === "pending") {
    reset();
    return;
  }
  current.style.transition = "";
  const threshold = Math.max(CLOSE_MIN, current.offsetHeight * CLOSE_RATIO);
  if (!cancelled && deltaY > threshold) {
    current.style.setProperty("--sheet-drag", `${deltaY}px`);
    current.style.transform = "";
    const host = current.closest("dialog-component");
    if (host && typeof host.closeDialog === "function") {
      host.closeDialog().finally(() => current.style.removeProperty("--sheet-drag"));
    } else {
      current.close();
      current.style.removeProperty("--sheet-drag");
    }
  } else {
    current.style.transition = "transform 200ms ease";
    current.style.transform = "translateY(0)";
    current.addEventListener(
      "transitionend",
      () => {
        current.style.transition = "";
        current.style.transform = "";
      },
      { once: true }
    );
  }
  sheet = null;
  mode = "idle";
  canDismiss = false;
  stageEl = null;
  deltaY = 0;
  deltaX = 0;
}
document.addEventListener("touchstart", onTouchStart, { passive: true, capture: true });
document.addEventListener("touchmove", onTouchMove, { passive: false });
document.addEventListener("touchend", onTouchEnd, { passive: true });
document.addEventListener("touchcancel", onTouchEnd, { passive: true });
document.addEventListener(
  "mousedown",
  (event) => {
    if (closestOpenSheet(event.target)) {
      event.stopPropagation();
    }
  },
  { capture: true }
);
function activateUpsellThumb(thumb) {
  const gallery = thumb.closest(".upsell-info-modal__gallery");
  if (!gallery) {
    return;
  }
  const mainImg = gallery.querySelector(".upsell-info-modal__main-image");
  if (!mainImg) {
    return;
  }
  mainImg.src = thumb.dataset.imgSrc;
  mainImg.alt = thumb.dataset.imgAlt || mainImg.alt;
  gallery.querySelectorAll(".upsell-info-modal__thumb").forEach((t) => {
    t.classList.toggle("is-active", t === thumb);
  });
  const strip = thumb.closest(".upsell-info-modal__thumbnails");
  if (strip) {
    const left = thumb.offsetLeft - strip.clientWidth / 2 + thumb.clientWidth / 2;
    strip.scrollTo({ left, behavior: "smooth" });
  }
}
document.addEventListener("click", (e) => {
  const thumb = e.target.closest(".upsell-info-modal__thumb");
  if (thumb) {
    activateUpsellThumb(thumb);
    return;
  }
  const nav = e.target.closest(".upsell-info-modal__nav");
  if (!nav) {
    return;
  }
  const gallery = nav.closest(".upsell-info-modal__gallery");
  if (!gallery) {
    return;
  }
  const thumbs = [...gallery.querySelectorAll(".upsell-info-modal__thumb")];
  if (thumbs.length === 0) {
    return;
  }
  const current = thumbs.findIndex((t) => t.classList.contains("is-active"));
  const dir = nav.classList.contains("upsell-info-modal__nav--next") ? 1 : -1;
  const next = (current + dir + thumbs.length) % thumbs.length;
  activateUpsellThumb(thumbs[next]);
});
